import mq from "backpack-ui/dist/styles/mq";
import * as cn from "classnames";
import * as React from "react";
import Picture from "../../../../shared/components/picture";
import * as styles from "./styles.css";
var url = function (src, size) { return src + "?fit=crop&w=" + size.width + "&h=" + size.height; };
var srcSet = function (src, size) { return (url(src, size) + ", " +
    (url(src, {
        height: size.height * 2,
        width: size.width * 2,
    }) + " 2x")); };
var HeroPhoto = function (_a) {
    var src = _a.src, sizes = _a.sizes, alt = _a.alt, className = _a.className;
    return (React.createElement(Picture, { className: cn(styles.heroPhoto, className), srcSet: srcSet(src, sizes[320]), src: url(src, sizes[320]), alt: alt, sources: [
            {
                media: "(min-width: " + mq.layout.laptopStart + ")",
                srcSet: srcSet(src, sizes[1024]),
            },
            {
                media: "(min-width: " + mq.layout.tabletStart + ")",
                srcSet: srcSet(src, sizes[768]),
            },
            {
                media: "(min-width: " + mq.min[480] + ")",
                srcSet: srcSet(src, sizes[480]),
            },
        ] }));
};
export default HeroPhoto;



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/patterns/hero/heroPhoto.tsx
// module id = /plJ
// module chunks = 2